import React from 'react';

import { isEmpty } from 'lodash';
import { bool, func, string } from 'prop-types';

import { faCircleQuestion } from '@fortawesome/pro-solid-svg-icons/faCircleQuestion';

import Button from 'components/Common/Buttons/ButtonV2';

import FontAwesomeIcon from 'components/Common/FontAwesomeIcon';

import s from './HowToUseThisFeatureButton.css';

const DEFAULT_BUTTON_LABEL = 'How to use this feature';

const HowToUseThisFeatureButton = ({
  buttonLabel,
  moduleHasFeatureOnboarding,
  featureOnboardingModalOpen,
  setFeatureOnboardingModalOpen,
}) =>
  moduleHasFeatureOnboarding ? (
    <Button
      onClick={() => setFeatureOnboardingModalOpen(!featureOnboardingModalOpen)}
      className={s.helpButton}
      color="secondary"
      variant="filled"
    >
      {!isEmpty(buttonLabel) ? buttonLabel : DEFAULT_BUTTON_LABEL}{' '}
      <FontAwesomeIcon icon={faCircleQuestion} className={s.help} />
    </Button>
  ) : null;

HowToUseThisFeatureButton.propTypes = {
  buttonLabel: string,
  moduleHasFeatureOnboarding: bool.isRequired,
  featureOnboardingModalOpen: bool.isRequired,
  setFeatureOnboardingModalOpen: func.isRequired,
};

HowToUseThisFeatureButton.defaultProps = {
  buttonLabel: DEFAULT_BUTTON_LABEL,
};

export default HowToUseThisFeatureButton;
